document.addEventListener('DOMContentLoaded', function() {
    let splitProfil = document.querySelector('#main-container .split-profil');
    let dropdownHeaderMenu = document.querySelector('#dropdown-header-menu');
    let navbar = document.querySelector('.main-block');
    if (dropdownHeaderMenu) {
        dropdownHeaderMenu.addEventListener('click', function () {
            if (!dropdownHeaderMenu.classList.contains('open')) {
                navbar.classList.add('black');
            } else {
                navbar.classList.remove('black');
            }
        });
    }
    window.addEventListener('scroll', function() {
        if (!splitProfil) {
            let header = document.querySelector('.main-block');
            if (window.scrollY > 150) {
                header.classList.add('scroll');
            } else {
                header.classList.remove('scroll');
            }
        }
    });
});